import createReducer from "./createReducer";

const initialState = {
	isLoading: false,
	hasErrorLoading: false,
	data: {},
	errors: [],
	errorDescription: "",
};

const CREATE_CONTENT_FEED_DECISIONING_ACTIONS = {
	CREATE_CONTENT_FEED_DECISIONING_AJAX: "CREATE_CONTENT_FEED_DECISIONING_AJAX",
	CREATE_CONTENT_FEED_DECISIONING_SUCCESS: "CREATE_CONTENT_FEED_DECISIONING_SUCCESS",
	CREATE_CONTENT_FEED_DECISIONING_ERROR: "CREATE_CONTENT_FEED_DECISIONING_ERROR",
};

const UPDATE_CONTENT_FEED_DECISIONING_ACTIONS = {
	UPDATE_CONTENT_FEED_DECISIONING_AJAX: "UPDATE_CONTENT_FEED_DECISIONING_AJAX",
	UPDATE_CONTENT_FEED_DECISIONING_SUCCESS: "UPDATE_CONTENT_FEED_DECISIONING_SUCCESS",
	UPDATE_CONTENT_FEED_DECISIONING_ERROR: "UPDATE_CONTENT_FEED_DECISIONING_ERROR",
};

const GET_CONTENT_FEED_DECISIONING_ACTIONS = {
	GET_CONTENT_FEED_DECISIONING_AJAX: "GET_CONTENT_FEED_DECISIONING_AJAX",
	GET_CONTENT_FEED_DECISIONING_SUCCESS: "GET_CONTENT_FEED_DECISIONING_SUCCESS",
	GET_CONTENT_FEED_DECISIONING_ERROR: "GET_CONTENT_FEED_DECISIONING_ERROR",
};

export const RESET_CONTENT_FEED_DECISIONING_MODAL = "RESET_CONTENT_FEED_DECISIONING_MODAL_STATE";

const CREATE_CONTENT_FEED_DECISIONING_HANDLERS = {
	[CREATE_CONTENT_FEED_DECISIONING_ACTIONS.CREATE_CONTENT_FEED_DECISIONING_AJAX]: onMetanodeRequest,
	[CREATE_CONTENT_FEED_DECISIONING_ACTIONS.CREATE_CONTENT_FEED_DECISIONING_SUCCESS]: onMetanodeSuccess,
	[CREATE_CONTENT_FEED_DECISIONING_ACTIONS.CREATE_CONTENT_FEED_DECISIONING_ERROR]: onMetanodeError,
};

const UPDATE_CONTENT_FEED_DECISIONING_HANDLERS = {
	[UPDATE_CONTENT_FEED_DECISIONING_ACTIONS.UPDATE_CONTENT_FEED_DECISIONING_AJAX]: onMetanodeRequest,
	[UPDATE_CONTENT_FEED_DECISIONING_ACTIONS.UPDATE_CONTENT_FEED_DECISIONING_SUCCESS]: onMetanodeSuccess,
	[UPDATE_CONTENT_FEED_DECISIONING_ACTIONS.UPDATE_CONTENT_FEED_DECISIONING_ERROR]: onMetanodeError,
};

const GET_CONTENT_FEED_DECISIONING_HANDLERS = {
	[GET_CONTENT_FEED_DECISIONING_ACTIONS.GET_CONTENT_FEED_DECISIONING_AJAX]: onGetContentFeedDecisioningRequest,
	[GET_CONTENT_FEED_DECISIONING_ACTIONS.GET_CONTENT_FEED_DECISIONING_SUCCESS]: onSuccessGetContentFeedDecisioning,
	[GET_CONTENT_FEED_DECISIONING_ACTIONS.GET_CONTENT_FEED_DECISIONING_ERROR]: onErrorGetContentFeedDecisioning,
};

const CONTENT_FEED_DECISIONING_ACTIONS = {
	...CREATE_CONTENT_FEED_DECISIONING_ACTIONS,
	...UPDATE_CONTENT_FEED_DECISIONING_ACTIONS,
	...GET_CONTENT_FEED_DECISIONING_ACTIONS,
	RESET_CONTENT_FEED_DECISIONING_MODAL,
};

const handlers = {
	...CREATE_CONTENT_FEED_DECISIONING_HANDLERS,
	...UPDATE_CONTENT_FEED_DECISIONING_HANDLERS,
	...GET_CONTENT_FEED_DECISIONING_HANDLERS,
	[CONTENT_FEED_DECISIONING_ACTIONS.RESET_CONTENT_FEED_DECISIONING_MODAL]: resetState,
};

const reducerConfig = {
	typeRoot: "CONTENT_FEED_DECISIONING",
	actionTypes: CONTENT_FEED_DECISIONING_ACTIONS,
	actionCreators: {
		createContentFeedDecisioning,
		updateContentFeedDecisioning,
		resetContentFeedDecisioningModalState,
		getContentFeedDecisioning,
	},
	initialState,
	handlers,
};

function onMetanodeRequest(state, action) {
	return {
		...state,
		isLoading: true,
		hasErrorLoading: false,
		errors: [],
		errorDescription: "",
	};
}

function onMetanodeSuccess(state, action) {
	return {
		...state,
		isLoading: false,
	};
}

function onMetanodeError(state, action) {
	const { errors = [], description } = action.payload.errorObj;
	return {
		...state,
		isLoading: false,
		hasErrorLoading: true,
		errors,
		errorDescription: description,
	};
}

function onGetContentFeedDecisioningRequest(state, action) {
	return {
		...state,
		isLoading: true,
		hasErrorLoading: false,
		errors: [],
		errorDescription: "",
	};
}

function onSuccessGetContentFeedDecisioning(state, action) {
	return {
		...state,
		data: action.payload.data,
		isLoading: false,
	};
}

function onErrorGetContentFeedDecisioning(state, action) {
	return {
		...state,
		isLoading: false,
	};
}

function resetState() {
	return { ...initialState };
}

function _dispatchMetanodeAjax(creativeId, data, method, actionTypes) {
	return (dispatch) => {
		return dispatch({
			type: actionTypes.ajax,
			AJAX: {
				url: `ui/creatives/${creativeId}/metanode`,
				method,
				gateway: "dt",
				data,
				success: actionTypes.success,
				error: actionTypes.error,
			},
		});
	};
}

export function createContentFeedDecisioning(creativeId, data) {
	return _dispatchMetanodeAjax(creativeId, data, "post", {
		ajax: CONTENT_FEED_DECISIONING_ACTIONS.CREATE_CONTENT_FEED_DECISIONING_AJAX,
		success: CONTENT_FEED_DECISIONING_ACTIONS.CREATE_CONTENT_FEED_DECISIONING_SUCCESS,
		error: CONTENT_FEED_DECISIONING_ACTIONS.CREATE_CONTENT_FEED_DECISIONING_ERROR,
	});
}

export function updateContentFeedDecisioning(creativeId, data) {
	return _dispatchMetanodeAjax(creativeId, data, "put", {
		ajax: CONTENT_FEED_DECISIONING_ACTIONS.UPDATE_CONTENT_FEED_DECISIONING_AJAX,
		success: CONTENT_FEED_DECISIONING_ACTIONS.UPDATE_CONTENT_FEED_DECISIONING_SUCCESS,
		error: CONTENT_FEED_DECISIONING_ACTIONS.UPDATE_CONTENT_FEED_DECISIONING_ERROR,
	});
}

export function getContentFeedDecisioning(creativeId) {
	return (dispatch) => {
		return dispatch({
			type: CONTENT_FEED_DECISIONING_ACTIONS.GET_CONTENT_FEED_DECISIONING_AJAX,
			AJAX: {
				url: `ui/creatives/${creativeId}/metanode`,
				gateway: "dt",
				method: "get",
				success: CONTENT_FEED_DECISIONING_ACTIONS.GET_CONTENT_FEED_DECISIONING_SUCCESS,
				error: CONTENT_FEED_DECISIONING_ACTIONS.GET_CONTENT_FEED_DECISIONING_ERROR,
			},
			meta: {
				suppressErrorGrowl: true,
				suppressGrowl: true,
			},
		});
	};
}

export function resetContentFeedDecisioningModalState() {
	return (dispatch) => {
		dispatch({
			type: RESET_CONTENT_FEED_DECISIONING_MODAL,
		});

		return Promise.resolve({ success: true });
	};
}

export default createReducer(reducerConfig.initialState, reducerConfig.handlers);
